import React, { createContext, useState, useEffect, useRef } from "react";
import { AuthService } from "../services/AuthService";
import { StorageService } from "../services/StorageService";
import { STORAGE_KEYS } from "../constants";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN));
  const [savedUsername, setSavedUsername] = useState(StorageService.getRememberedID());
  const [token, setToken] = useState(StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN));
  const prevToken = useRef(token);

  useEffect(() => {
    if (token && prevToken.current !== token) {
      const verifyToken = async () => {
        const isValid = await AuthService.autoLogin();
        setIsAuthenticated(isValid);
      };
      verifyToken();
    } else if (!token) {
      setIsAuthenticated(false);
    }
    prevToken.current = token;
  }, [token]); // token이 변경될 때만 autoLogin 호출

  const login = async (username, password, rememberMe, autoLogin) => {
    const success = await AuthService.login(username, password, rememberMe, autoLogin);
    if (success) {
      setIsAuthenticated(true);
      setSavedUsername(username);
      setToken(StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN));
     }
  };

  const logout = () => {
    AuthService.logout();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, savedUsername, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
